module.exports = __webpack_public_path__ + "static/img/demoImage3.a42d141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demoImage3.png
// module id = AhTB
// module chunks = 3